import React from 'react';
import { Route } from 'react-router';
import permission from './screens/Permission/router';
import permissionSearch from './screens/PermissionSearch/router';
import siteSetting from './screens/SiteSetting/router';
export default (
  <Route path="companyspace"
    getComponent={(location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('./index'));
      });
    }}
  >
    {permission}
    {permissionSearch}
    {siteSetting}
  </Route>
);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/CompanySpace/router.js
 **/